import type { GanttData, Row, Task } from './types';
import { parseDate } from './dateUtils';
import { genId } from './idGen';

export const expandToSingleTaskRows = (state: GanttData): GanttData => {
  // Create a map for quick task lookup to get their startDates
  const taskMap = new Map<string, Task>();
  state.tasks.forEach(t => taskMap.set(t.id, t));

  const newRows: Row[] = [];

  state.rows.forEach(row => {
    if (row.taskIds.length <= 1) {
      // Keep the row as is if it's empty or already has only one task
      newRows.push({ ...row });
    } else {
      // Row has multiple tasks, need to split them
      
      // Filter out invalid task IDs and sort the remaining ones by startDate
      const tasksInRow = row.taskIds
        .map(taskId => taskMap.get(taskId))
        .filter((t): t is Task => t !== undefined);

      tasksInRow.sort((a, b) => {
        const startA = parseDate(a.startDate).getTime();
        const startB = parseDate(b.startDate).getTime();
        return startA - startB;
      });

      // Assign the first task to the existing row ID to preserve identity where possible
      if (tasksInRow.length > 0) {
        newRows.push({
          id: row.id,
          taskIds: [tasksInRow[0].id],
        });

        // Put remaining tasks into completely new rows
        for (let i = 1; i < tasksInRow.length; i++) {
          newRows.push({
            id: genId('row'),
            taskIds: [tasksInRow[i].id],
          });
        }
      }
    }
  });

  return {
    ...state,
    rows: newRows,
  };
};
